import { Api } from '@/services/Api';

export default {
  /*  1. Get all data */
  getProvideLaptopByCriteria(body = { keyword: '' }) {
    return Api().post('/ProvideLaptop/GetProvideLaptopByCriteria', body);
  },
  /*  2. Get one column */
  getProvideLaptop(id) {
    return Api().get(`/ProvideLaptop/${id}`);
  },
  /*  3. Create one column */
  saveProvideLaptop(body) {
    return Api().post(`/ProvideLaptop`, body);
  },
  /*  4. Delete one or more columns */
  deleteProvideLaptop(body) {
    return Api().post(`/ProvideLaptop/DeleteProvideLaptop`, body);
  },
  /*  5. post one or more columns */
  postProvideLaptop(body) {
    return Api().post(`/ProvideLaptop/PostProvideLaptop`, body);
    },
    startWF(body) {
        return Api().post(`/ProvideLaptop/StartWF`, body);
    }
};
